import React from 'react';
import api from '../../../services/api';
import RModal from '../../../components/Rsuite/Modal';
import { CustomButton } from '../../../components/CustomButton';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { toastSuccess, toastError } from '../../../toasts';

const BairroDelete = ({ open, close, bairro, setBairros }) => {
  const { theme } = useCustomTheme();
  const deletarBairro = async () => {
    await api
      .delete(`bairro/deletar/${bairro.Id}`)
      .then(() => {
        toastSuccess('Bairro deletado');
        setBairros((state) => state.filter((x) => x.Id !== bairro.Id));
        close();
      })
      .catch(() => {
        toastError('Erro ao excluir bairro');
      });
  };

  return (
    <RModal
      open={open}
      onClose={close}
      title={`Deletar Bairro > ${bairro.Bairro}`}
      footer={
        <>
          <CustomButton onClick={deletarBairro} appearance="primary">
            Deletar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <span style={{ color: theme.colors.textSecondary }}>
        Tem certeza que deseja deletar o bairro?
      </span>
    </RModal>
  );
};

export default BairroDelete;
